import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleLogo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 24,
	viewBox: "0 0 23 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_198_11340)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M19.5316 21.0614C22.3133 18.4174 23.5495 14.0108 22.8078 9.79297H11.7432V14.4514H18.0481C17.8009 15.9623 16.9354 17.2213 15.6992 18.0397L19.5316 21.0614Z",
					fill: "#4285F4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.23535 17.3474C1.33664 17.5504 1.44344 17.7504 1.55574 17.9474C1.66812 18.1444 1.78584 18.3379 1.90888 18.5281C2.03201 18.7183 2.16022 18.9048 2.29367 19.0875C2.42712 19.2704 2.56547 19.4491 2.7089 19.624C2.85224 19.7988 3.0003 19.9694 3.15319 20.1357C3.30599 20.302 3.46334 20.4637 3.62517 20.621C3.78699 20.7782 3.95303 20.9306 4.12328 21.0784C4.29354 21.226 4.46774 21.3687 4.64599 21.5063C4.82416 21.644 5.00602 21.7764 5.19158 21.9035C5.37713 22.0307 5.56605 22.1524 5.7584 22.2687C5.95066 22.385 6.14602 22.4957 6.34448 22.6008C6.54294 22.7058 6.74414 22.8051 6.9481 22.8985C7.15206 22.9919 7.35843 23.0795 7.56729 23.161C7.77606 23.2427 7.98699 23.3181 8.19998 23.3876C8.41296 23.457 8.62776 23.5203 8.84427 23.5774C9.06078 23.6344 9.27867 23.6852 9.49802 23.7298C9.71737 23.7743 9.93776 23.8125 10.1593 23.8444C10.3807 23.8761 10.6029 23.9016 10.8257 23.9206C11.0486 23.9396 11.2718 23.9523 11.4954 23.9585C11.719 23.9647 11.9425 23.9644 12.1661 23.9578C12.3897 23.9511 12.6128 23.938 12.8357 23.9184C13.0585 23.8989 13.2806 23.873 13.502 23.8407C13.7234 23.8084 13.9437 23.7697 14.1629 23.7246C14.3822 23.6796 14.6 23.6284 14.8164 23.5709C15.0328 23.5133 15.2474 23.4496 15.4603 23.3797C15.6731 23.3098 15.8839 23.2338 16.0926 23.1518C16.3012 23.0697 16.5074 22.9818 16.7111 22.8878C16.9149 22.794 17.1159 22.6943 17.3141 22.5888C17.5124 22.4833 17.7075 22.3722 17.8996 22.2555C18.0916 22.1388 18.2802 22.0166 18.4655 21.8891C18.6508 21.7615 18.8324 21.6287 19.0103 21.4906C19.1882 21.3526 19.3622 21.2095 19.5321 21.0616L15.6997 18.0399C12.4236 20.2431 6.98404 19.4248 5.12958 14.2627L1.23535 17.3474Z",
					fill: "#34A853"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.12905 14.2622C4.63454 12.6884 4.63454 11.2405 5.12905 9.66669L1.23482 6.58203C-0.18688 9.47789 -0.619562 13.5697 1.23482 17.3468L5.12905 14.2622Z",
					fill: "#FBBC02"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.12958 9.6672C6.48954 5.32354 12.3 2.80546 16.1942 6.51958L19.5939 3.12019C14.7725 -1.60115 5.37688 -1.41235 1.23535 6.58254L5.12958 9.6672Z",
					fill: "#EA4335"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_198_11340",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 23,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgGoogleLogo);
export { ForwardRef as ReactComponent };
